import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=4f27e6e5&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=4f27e6e5&prod&scoped=true&lang=scss"
import style1 from "./video-detail.vue?vue&type=style&index=1&id=4f27e6e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27e6e5",
  null
  
)

export default component.exports